<template>
    <ul class="user-info-chip-list">
        <li class="user-info-chip-item" v-for="item in props.chipTextList" :key="item">
            {{ item }}
        </li>
    </ul>
</template>

<script setup lang="ts">
const props = defineProps<{
    chipTextList: string[];
}>();
</script>

<style scoped lang="scss">
.user-info-chip-list {
    display: flex;
}

.user-info-chip-item {
    padding: 0 0.5rem;
    border-radius: 0.5rem;
    background-color: $grey-2;
    color: $grey-7;
    font-size: 1.1rem;
    line-height: 160%;
    font-weight: 700;

    & + .user-info-chip-item {
        margin-left: 0.5rem;
    }
}

.user-info-chip-item p {
    color: var(--primary-black);
}
</style>
